import { Box, Flex, Group, SegmentedControl, Select, Switch, Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks";
import { IRootState } from "../../../../../../store";
import {
  setSvarGantEndDateInRedux,
  setSvarGantSkipItemsWithoutEndDateInRedux,
  setSvarGantStartDateInRedux,
  setSvarGantZoomLevelInRedux,
} from "../../../issueSlice"; // Adjust path to your slice file
import { GanttInterval, thunkSetSvarGantDateRange } from "../../../issueThunk";

const SvarGantActionBar = () => {
  const dispatch = useAppDispatch();
  const zoomLevel = useAppSelector((s: IRootState) => s.issueReducerNew.svarGant.zoomLevel || "week");
  const startDate = useAppSelector((s: IRootState) => s.issueReducerNew.svarGant.startDate);
  const endDate = useAppSelector((s: IRootState) => s.issueReducerNew.svarGant.endDate);
  const skipItemsWithoutEndDate = useAppSelector((s: IRootState) => s.issueReducerNew.svarGant.skipItemsWithoutEndDate);

  return (
    <Box py="xs" px={"sm"} bg="warmgray.1" style={{ borderBottom: "1px solid #ddd" }}>
      <Group align="center" gap="sm">
        <Flex align="center" gap="xs">
          <Text size="sm">Tidsrom:</Text>
          <Select
            data={[
              { value: GanttInterval.ThisYear, label: "Dette året" },
              { value: GanttInterval.ThisQuarter, label: "Dette kvartalet" },
              { value: GanttInterval.NextThreeMonths, label: "Neste 3 måneder" },
            ]}
            placeholder="Velg tidsrom"
            size="sm"
            maw={170}
            w="100%"
            onChange={(value) => dispatch(thunkSetSvarGantDateRange(value as GanttInterval))}
          />
        </Flex>
        <Flex align="center" gap="xs">
          <Text>Fra:</Text>
          <DateInput
            value={startDate || null}
            onChange={(val) => dispatch(setSvarGantStartDateInRedux(val))}
            clearable
            maxDate={endDate}
            valueFormat="DD-MM-YYYY"
            placeholder="Velg dato"
            maw={170}
            w="100%"
          />
        </Flex>
        <Flex align="center" gap="xs">
          <Text>Til:</Text>
          <DateInput
            value={endDate || null}
            onChange={(val) => dispatch(setSvarGantEndDateInRedux(val))}
            clearable
            minDate={startDate}
            valueFormat="DD-MM-YYYY"
            placeholder="Velg dato"
            maw={170}
            w="100%"
          />
        </Flex>
        <Flex align="center" gap="xs">
          <SegmentedControl
            value={zoomLevel}
            bg={"warmgray.2"}
            onChange={(val) => dispatch(setSvarGantZoomLevelInRedux(val as "week" | "month"))}
            data={[
              { label: "Uke", value: "week" },
              { label: "Måned", value: "month" },
            ]}
            size="sm"
          />
        </Flex>
        <Flex align="center">
          <Switch
            label="Skjul saker uten sluttdato"
            checked={skipItemsWithoutEndDate}
            onChange={(event) => dispatch(setSvarGantSkipItemsWithoutEndDateInRedux(event.currentTarget.checked))}
            size="sm"
          />
        </Flex>
      </Group>
    </Box>
  );
};

export default SvarGantActionBar;
